
import { useParams } from "react-router-dom";
import { useDashboardContext } from "../../../context/dashboardContext";
import { InstrumentAmountDTOInstrumentEnum, PieceDTO } from "../../../openapi-generated-client";
import DashboardEditPiece from "./dashboardEditPiece";
import { useEffect } from "react";

export default function DashboardCreatePiecePage() {

    const {artistId} = useParams();

    useEffect(() => {
        if(artistId != undefined && isNaN(Number(artistId))) {
            window.location.href = "/error/2";
            return;
        }
    }, [artistId]);

    const {sessionId, appContext} = useDashboardContext();
    
    const {pieceController} = appContext;

    return <DashboardEditPiece defaultPiece={{
        title: "",
        description: "",
        price: 0,
        duration: 0,
        year: new Date().getFullYear(),
        keywords: [],
        instruments: [
            {
                instrument: InstrumentAmountDTOInstrumentEnum.Accordion,
                amount: 1
            }
        ],
        orchestralInstruments: undefined,
        performances: [],
        contributors: [],
        original: false,
        difficulty: -1,
        transcriptionInfo: {
            artistId: -1,
            name: "",
            realYear: 1900
        },
        scores: [],
        previewHash: undefined,
        thumbnailHash: undefined,
        customThumbnail: false,
        previewPageCount: 1,
        generateThumbnailFromPage: 1,
        externalScoreLink: undefined,
        pages: undefined
    }} onUpdate={async (piece: PieceDTO) => {
        if(artistId) {
            try {
                await pieceController.uploadPiece1(sessionId, parseInt(artistId), piece);
            } catch (e) {
                const errorMessage = e instanceof Error ? e.message : String(e);
                console.log("error uploading piece", errorMessage);
                return errorMessage;
            }
        }else {
            try {
                await pieceController.uploadPiece(sessionId, piece);
            } catch (e) {
                const errorMessage = e instanceof Error ? e.message : String(e);
                console.log("error uploading piece", errorMessage);
                return errorMessage;
            }

        }
        return "";
    }}/>

}
